module.exports = "/_next/static/images/Introduction-56e12d4f62aae4b0915304eaf23de1d3.webp";